import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { StaticImage } from '../../../../../image'
import ImgManWithCard from '../../../../images/ImgManWithCard.png'

const accentuate = (text: ReactNode[]): JSX.Element => (
  <span className="text-justify text-3xl font-medium desktop:text-4xl desktop:leading-3xl">
    {text}
  </span>
)

export const ErxBonusLandingPageHeroV1: FC = () => {
  const intl = useIntl()

  return (
    <div className="flex justify-center">
      <div className="flex w-full justify-center">
        <StaticImage
          alt={intl.formatMessage({ id: 'general.link.label.recipe' })}
          className="w-3/5 object-contain"
          src={ImgManWithCard}
        />
        <div className="-ml-10 mt-6 flex size-[124px] shrink-0 grow-0 items-center justify-center rounded-full bg-light-tertiary desktop:size-[150px]">
          <div className="mx-2 px-4 text-center align-text-top font-mono text-xs font-medium uppercase text-dark-primary-max desktop:px-6 desktop:text-m">
            <FormattedMessage
              id="deErx.bonus.hero.badge"
              values={{
                accentuate,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
